/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46
}, t = {
  backspace: "Backspace",
  tab: "Tab",
  enter: "Enter",
  shift: "Shift",
  esc: "Escape",
  space: " ",
  pageUp: "PageUp",
  pageDown: "PageDown",
  end: "End",
  home: "Home",
  left: "ArrowLeft",
  up: "ArrowUp",
  right: "ArrowRight",
  down: "ArrowDown",
  delete: "Delete"
};
export {
  t as KEYS,
  e as Keys
};
